import * as Yup from 'yup';
import { emailValidator, specialCharValidator } from '@/utility/validators';

export const resetPasswordSchema = Yup.object({
  currentPassword: Yup.string().required('Current Password is required'),
  newPassword: Yup.string()
    .min(8, 'Password must be at least 8 characters')
    .matches(/[A-Z]/, 'Must contain at least one uppercase letter')
    .matches(/[0-9]/, 'Must contain at least one number')
    .concat(specialCharValidator('Must contain at least one special character'))
    .matches(/^\S*$/, 'Password cannot contain spaces')
    .required('New Password is required'),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref('newPassword')], 'Passwords must match')
    .required('Confirm Password is required'),
});

export const resetForgotPasswordSchema = Yup.object({
  newPassword: Yup.string()
    .min(8, 'Password must be at least 8 characters')
    .matches(/[A-Z]/, 'Must contain at least one uppercase letter')
    .matches(/[0-9]/, 'Must contain at least one number')
    .concat(specialCharValidator('Must contain at least one special character'))
    .matches(/^\S*$/, 'Password cannot contain spaces')
    .required('New Password is required'),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref('newPassword')], 'Passwords must match')
    .required('Confirm Password is required'),
  });
  
export const resetTemporaryPasswordSchema = Yup.object({
  currentPassword: Yup.string().required('Temporary Password is required'),
  newPassword: Yup.string()
    .min(8, 'Password must be at least 8 characters')
    .matches(/[A-Z]/, 'Must contain at least one uppercase letter')
    .matches(/[0-9]/, 'Must contain at least one number')
    .concat(specialCharValidator('Must contain at least one special character'))
    .matches(/^\S*$/, 'Password cannot contain spaces')
    .required('New Password is required'),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref('newPassword')], 'Passwords must match')
    .required('Confirm Password is required'),
});


export const changePasswordSchema = Yup.object({
  currentPassword: Yup.string().required('Current Password is required'),
  newPassword: Yup.string()
    .min(8, 'Password must be at least 8 characters')
    .matches(/[A-Z]/, 'Must contain at least one uppercase letter')
    .matches(/[0-9]/, 'Must contain at least one number')
    .concat(specialCharValidator('Must contain at least one special character'))
    .matches(/^\S*$/, 'Password cannot contain spaces')
    .required('New Password is required'),
  confirmNewPassword: Yup.string()
    .oneOf([Yup.ref('newPassword')], 'Passwords must match')
    .required('Confirm Password is required'),
});

//  Forgot password schema
export const forgotPasswordSchema = Yup.object({
  email: emailValidator().required('Email is required'),
});

export const loginSchema = Yup.object({
  email: emailValidator().required('Email is required'),
  password: Yup.string().min(8).required('Password is required'),
});
